import React from 'react'
import { Container, Grid } from '@material-ui/core'
import { mdl } from '../../utils/ResponsiveUtility'
import MainNavigation from '../MainNavigation'
import { useStyles } from './Styles'
import { AuthConsumer } from '../../context/AuthContext'
import { FullBodyWithLogoLoader } from '../Loader/FullBodyWithLogoLoader'
import InActiveUserContent from '../InActiveUserContent'
import NotAuthorize from '../UnAuthorize'

const AccountLayout = ({ permission, content }) => {
  const classes = useStyles()
  const [width, setWidth] = React.useState(document.body.clientWidth)
  const DesktopAndUp = (width >= mdl)

  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])

  return (
    <AuthConsumer>
      {({ userDataLoading, taxpayerData, isUserActive, userPermissions }) => (
        <>
          {!!userDataLoading && <FullBodyWithLogoLoader loading={true}/>}
          {(!!Object.keys(taxpayerData).length && !!isUserActive) ?
            <div className={classes.contentWrapper}>
              <Container maxWidth={false} className={classes.accountLayoutContainer}>
                <Grid container className={classes.accountLayoutGridContainer}>
                  {DesktopAndUp &&
                  <AuthConsumer>
                    {({ currentRoleName }) => (
                      <MainNavigation userRoleName={currentRoleName}/>
                    )}
                  </AuthConsumer>}
                  <div className={classes.accountLayoutContent}>
                    {(!permission || !!userPermissions?.includes(permission || '')) ?
                      content : <NotAuthorize/>
                    }</div>
                </Grid>
              </Container>
            </div>
            : (!userDataLoading && <InActiveUserContent/>)
          }
        </>
      )}
    </AuthConsumer>
  )
}

export default AccountLayout
